module.exports = __webpack_public_path__ + "img/img22.5797a5c0.png";